module.exports = __webpack_public_path__ + "static/bg-invite.7a35dd27.png";